import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button';
import CookieBanner from '../components/CookieBanner';
import logo from '../assets/zwyk-logo-dark2.svg';
import adrenaliniumBadge from '../assets/adrenalinium_odznaka_main.svg';
import '../styles/AdrenaliniumSuccess.css';
import AOS from "aos";
import "aos/dist/aos.css";

const AdrenaliniumSuccess: React.FC = () => {
  useEffect(() => {
    AOS.init({
      once: true,
      duration: 600,
      easing: "ease-out-sine",
    });
  }, []);

  return (
    <div className="adrenalinium-success-page">
      <div className="adrenalinium-success-container">
        <div className="adrenalinium-success-header">
          <img width={100} height={'auto'} src={logo} alt="Zwyk Logo" />
        </div>
        
        <div className="adrenalinium-success-content" data-aos="fade-up">
          <div className="success-icon" data-aos="zoom-in" data-aos-delay={100}>
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="40" cy="40" r="38" stroke="#4caf50" strokeWidth="4"/>
              <path d="M25 40L35 50L55 30" stroke="#4caf50" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>

          <h1 className="success-title" data-aos="fade-up" data-aos-delay={200}>
            Dziękujemy za rejestrację!
          </h1>

          <div className="success-badge" data-aos="fade-up" data-aos-delay={300}>
            <img width={150} height={'auto'} src={adrenaliniumBadge} alt="Adrenalinium Badge" />
          </div>

          <div className="success-message" data-aos="fade-up" data-aos-delay={400}>
            <p>
              <strong>Twoja rejestracja w akcji Adrenalinium x ZWYK 2025 została przyjęta!</strong>
            </p>
            <p>
              Wkrótce otrzymasz na swój adres e-mail potwierdzenie rejestracji oraz szczegóły dotyczące odbioru odznaczenia.
            </p>
          </div>

          <div className="success-details" data-aos="fade-up" data-aos-delay={500}>
            <h3>Co dalej?</h3>
            <ul>
              <li>📧 Sprawdź swoją skrzynkę e-mail (również spam)</li>
              <li>🏔️ Przygotuj się na górskie wyzwania!</li>
              <li>📱 Śledź nasze social media, aby być na bieżąco</li>
              <li>🎯 Wkrótce udostępnimy wersję testową aplikacji ZWYK</li>
            </ul>
          </div>

          <div className="success-actions" data-aos="fade-up" data-aos-delay={600}>
            <Link to="/">
              <Button>Wróć do strony głównej</Button>
            </Link>
          </div>
        </div>
      </div>
      <CookieBanner />
    </div>
  );
};

export default AdrenaliniumSuccess;

